// src/pages/ContactUs.js
import React, { useState } from 'react';
import './ContactUs.css';
import { submitContactForm } from '../../services/contactService/contactService';
import { Helmet } from 'react-helmet';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await submitContactForm(formData);
      toast.success('Message sent successfully!');
      setFormData({ name: '', email: '', message: '' });
    } catch (error) {
      console.error('Form submission error:', error);
      toast.error('Something went wrong. Please try again later.');
    }
  };

  return (
    <section id="contact" className="contact-section">
      <Helmet>
        <title>UBR Engineering Works</title>
        <meta
          name="description"
          content="Get in touch with UBR Engineering Works for any inquiries or support related to industrial machinery. Reach us via phone, email, or the message form."
        />
        <meta
          name="keywords"
          content="Contact UBR Engineering, engineering company contact, industrial machinery support, UBR email, UBR phone, chat with UBR"
        />
        <meta name="author" content="UBR Engineering Works" />
      </Helmet>

      <div className="contact-wrapper">
        <div className="contact-heading">
          <h2>Get in Touch</h2>
          <p>We’d love to hear from you! Reach out via phone, email, or message form below.</p>
        </div>

        <div className="contact-content">
          <div className="contact-info-box">
            <h3>Contact Details</h3>
            <p><strong>📍 Address:</strong><br />H-1/214, RIICO Industrial Area, Chopanki , Bhiwadi , Rajasthan - 301019</p>
            <p><strong>📞 Phone:</strong><br /><a href="tel:+919582417861">+91 95824 17861</a></p>
            <p><strong>✉️ Email:</strong><br /><a href="mailto:ubrenggworks@gmail.com">ubrenggworks@gmail.com</a></p>

            <a
  className="whatsapp-premium"
  href="https://wa.me/919582417861"
  target="_blank"
  rel="noopener noreferrer"
  role="button"
>
  💬 Chat on WhatsApp
</a>

          </div>

          <form className="contact-form-premium" onSubmit={handleSubmit}>
            <label htmlFor="name">Name</label>
            <input
              id="name"
              type="text"
              name="name"
              placeholder="Your Name"
              required
              value={formData.name}
              onChange={handleChange}
              aria-label="Your Name"
            />

            <label htmlFor="email">Email</label>
            <input
              id="email"
              type="email"
              name="email"
              placeholder="Your Email"
              required
              value={formData.email}
              onChange={handleChange}
              aria-label="Your Email"
            />

            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Your Message"
              rows="5"
              required
              value={formData.message}
              onChange={handleChange}
              aria-label="Your Message"
            ></textarea>

            <button type="submit">Send Message</button>
          </form>
        </div>
      </div>

      <ToastContainer position="bottom-right" />
    </section>
  );
};

export default ContactUs;
